export const data = [
  {
    pair: "DELFC4 - ggnfc5",
    value: 2786310,
    otif: 89.2417368762152,
    quantity: 1559
  },
  {
    pair: "DELFC4 - ggnfc8",
    value: 2940929,
    otif: 89.9546338302009,
    quantity: 1557
  },
  {
    pair: "DELFC4 - ggnfc7",
    value: 6539349,
    otif: 89.9916364650125,
    quantity: 3626
  },
  {
    pair: "DELFC4 - ggnfc6",
    value: 1865180,
    otif: 90.1066925315228,
    quantity: 1054
  }
];

export const displayedColumns5 = ["pair", "otif", "value", "quantity"];
